import { render, staticRenderFns } from "./LandParcelCommon.vue?vue&type=template&id=0f350964&scoped=true&"
import script from "./LandParcelCommon.vue?vue&type=script&lang=js&"
export * from "./LandParcelCommon.vue?vue&type=script&lang=js&"
import style0 from "./LandParcelCommon.vue?vue&type=style&index=0&id=0f350964&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f350964",
  null
  
)

export default component.exports